var _defs, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOkex = function SvgOkex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1167.82 1167.82",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7abdf7;}.cls-2{fill:#0d74f5;}.cls-3{fill:#4494f7;}.cls-4{fill:#005cf4;}.cls-5{fill:#186ef9;}.cls-6{fill:#0246f2;}.cls-7{fill:#0046f8;}.cls-8{fill:#0729f1;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u8D44\u6E90 1")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.05,521.05a264.44,264.44,0,0,0,125.72,0A264.65,264.65,0,0,1,840.64,327.17a264.64,264.64,0,0,0,7.59-62.85C848.23,118.34,729.89,0,583.91,0S319.59,118.34,319.59,264.32a264.64,264.64,0,0,0,7.59,62.85A264.67,264.67,0,0,1,521.05,521.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M646.77,646.77a264.1,264.1,0,0,0-125.72,0A264.66,264.66,0,0,1,327.18,840.64a264.73,264.73,0,0,0-7.59,62.86c0,146,118.34,264.32,264.32,264.32S848.23,1049.48,848.23,903.5a264.73,264.73,0,0,0-7.59-62.86A264.64,264.64,0,0,1,646.77,646.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M903.5,319.59a265.24,265.24,0,0,0-62.86,7.58A264.64,264.64,0,0,1,646.77,521.05a264.1,264.1,0,0,0,0,125.72A264.61,264.61,0,0,1,840.64,840.64a264.73,264.73,0,0,0,62.86,7.59c146,0,264.32-118.34,264.32-264.32S1049.48,319.59,903.5,319.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M521.05,646.77a264.44,264.44,0,0,0,0-125.72A264.64,264.64,0,0,1,327.18,327.17a265.24,265.24,0,0,0-62.86-7.58C118.34,319.59,0,437.93,0,583.91S118.34,848.23,264.32,848.23a264.73,264.73,0,0,0,62.86-7.59A264.61,264.61,0,0,1,521.05,646.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M646.77,521.05A264.64,264.64,0,0,0,840.64,327.17,264.65,264.65,0,0,0,646.77,521.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M646.77,646.77A264.64,264.64,0,0,0,840.64,840.64,264.61,264.61,0,0,0,646.77,646.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M521.05,521.05A264.67,264.67,0,0,0,327.18,327.17,264.64,264.64,0,0,0,521.05,521.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M521.05,646.77A264.61,264.61,0,0,0,327.18,840.64,264.66,264.66,0,0,0,521.05,646.77Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOkex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/okex.923b3364.svg";
export { ForwardRef as ReactComponent };